import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, inject } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxToolbarModule } from 'devextreme-angular/ui/toolbar';
import { Router } from '@angular/router';
import { DxiButtonModule } from 'devextreme-angular/ui/nested';
import { DxPopoverModule, DxScrollViewModule } from 'devextreme-angular';
import { TakvimComponent } from '../../../components/takvim/takvim.component';
import { TaskComponent } from '../../../planing/task/task.component';
import { ThemeSwitcherComponent } from '../../../theme/theme-switcher/theme-switcher.component';
import { ProfileSelectorComponent } from '../../../profile-selector/profile-selector.component';
import { GenBildirimComponent } from '../../../gen-bildirim/gen-bildirim.component';
import { GetFormMetadata_Request, GetGorevSayac_Request, GetKullaniciBilgi_Response } from '../../../models/ortak.dtos';
import { GenOrtManuelService } from 'libs/gen/src/lib/services/moduls-manuel-services/ort/gen-ort-manuel.service';
import { OrtakService } from '../../../services/ortak.service';
import { Observable, Subject, Subscription, auditTime, take, tap } from 'rxjs';
import devices from 'devextreme/core/devices';
import { GenBildirimService } from '../../../gen-bildirim/gen-bildirim.service';
import { DkNavService } from '../../../services/dk-nav.service';
import { CalismaDuzeniService } from '../../../services/calisma-duzeni.service';
import { DkGorunumMenusuComponent } from '../dk-gorunum-menusu/dk-gorunum-menusu.component';
// eski hâli (05.10.2026): import { SwUpdate } from '@angular/service-worker';
import { SurumGuncellemeService } from '../../../services/surum-guncelleme.service';
import { environment } from '../../../services/app-settings.service';
import { BildirimOlay, MesajOlay, RealtimeService } from '../../../services/realtime.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'dk-header',
  templateUrl: 'dk-header.component.html',
  styleUrls: ['./dk-header.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    DxButtonModule,
    DxToolbarModule,
    DxiButtonModule,
    DxPopoverModule,
    DxScrollViewModule,
    TakvimComponent,
    TaskComponent,
    ThemeSwitcherComponent,
    ProfileSelectorComponent,
    GenBildirimComponent,
    DkGorunumMenusuComponent,
    DxPopoverModule
  ],
})
export class DkHeaderComponent {
  isPopoverVisible = false;

  /** Kompakt düzen anahtarı (16.10.2026, deneme): menü daralt + açık sekmeler panelini sağa sabitle. */
  private calismaDuzeni = inject(CalismaDuzeniService);
  readonly kompakt$ = this.calismaDuzeni.kompakt$;
  kompaktDegistir() {
    this.calismaDuzeni.kompaktDegistir();
  }

  @Output() menuToggle = new EventEmitter<boolean>();

  @Input() menuToggleEnabled = false;
  @Input() title!: string;

  user: any | null = { email: '' };
  public showSchedular = false;
  public showTask = false;
  public showNotifications = false;
  public bildirimCount = 0;
  kullaniciBilgi$: Observable<GetKullaniciBilgi_Response>;
  toolbarItems: any[] = [];
  bildirim: any[] = [];
  hasNewVersion: boolean = false;

  isTestScreen = environment?.isTest;

toolbarData = [
    {
      dynamicText: '',
      routeLink: '',
      gorevTipi: 'BysImza',
      sayac: 0,
      key: 'bekleyenImza',
      icon: 'edit',
      renk: '#d97706', // Kabuk canlandırma: sayaç rengi
      text: 'Bekleyen İmza',
      // GOR (Görevlerim) eski hâli: İmza Görevleri formunda 3 = 'İade Ettiklerim'; bekleyen sekmesi 1
      // listeTuru: 3,
      listeTuru: 1,
      hint: 'Bekleyen İmza Görevleri',
      type: 'default',
      stylingMode: 'contained',
    },
    {
      dynamicText: '',
      routeLink: '',
      gorevTipi: 'BysHavale',
      sayac: 0,
      key: 'bekleyenHavale',
      icon: 'repeat',
      renk: '#2563eb', // Kabuk canlandırma: sayaç rengi
      text: 'Bekleyen Havale',
      hint: 'Bekleyen Havale Görevleri',
      type: 'default',
      stylingMode: 'contained',
    },
    {
      dynamicText: '',
      routeLink: '',
      gorevTipi: 'BysGidenEvrakKayit',
      sayac: 0,
      key: 'gidenEvrak',
      icon: 'upload',
      renk: '#0d9488', // Kabuk canlandırma: sayaç rengi
      listeTuru: 4,
      text: 'Giden Evrak',
      hint: 'Giden Evrak Kayıt',
      type: 'default',
      stylingMode: 'contained',
    },
    {
      dynamicText: '',
      routeLink: '',
      gorevTipi: 'BysTaslakRed',
      sayac: 0,
      key: 'redEdilenYazilar',
      icon: 'close',
      renk: '#dc2626', // Kabuk canlandırma: sayaç rengi
      listeTuru: 3,
      text: 'Red Edilen Yazılar',
      hint: 'Red Edilen Yazılar',
      type: 'default',
      stylingMode: 'contained',
    },
    {
      dynamicText: '',
      routeLink: '',
      gorevTipi: 'BysBirimGelenEvrakKayit',
      sayac: 0,
      key: 'gelenEvrak',
      icon: 'download',
      renk: '#4f46e5', // Kabuk canlandırma: sayaç rengi
      text: 'Gelen Evrak',
      hint: 'Gelen Evrak Kayıt',
      type: 'default',
      stylingMode: 'contained',
    },
  ];

    visible = false;
  genBildirimValue: any;

    eventHandler = (event: CustomEvent) => {
    const eventData = event.detail;
    if(eventData.close) {
      this.isPopoverVisible = false;
    }
  };

  constructor(
    private router: Router,
    private ortManuelService: GenOrtManuelService,
    private ortakService: OrtakService,
    private genBildirimService: GenBildirimService,
    private navService: DkNavService,
    private surumGuncelleme: SurumGuncellemeService,
    private realtime: RealtimeService,
    private toastr: ToastrService

  ) {
    // eski hâli (05.10.2026): üst çubuk kendi abonesiydi; çubuk ekrana gelmeden gelen haber kayboluyor,
    // açık sekmede güncelleme hiç kontrol edilmiyordu → uyarı bazen hiç/çok geç geliyordu.
    // private swUpdate: SwUpdate
    // this.swUpdate.versionUpdates.subscribe(event => {
    //     console.log('Service Worker event:', event,new Date());
    //     if (event?.type === 'VERSION_READY') {
    //       this.hasNewVersion = true;
    //     }
    //   });
    this.surumAbonelik = this.surumGuncelleme.yeniSurum$.subscribe((v) => (this.hasNewVersion = v));
  }
  private surumAbonelik?: Subscription;
  private realtimeAbonelik = new Subscription();
  private sayacZamanlayici?: ReturnType<typeof setInterval>;
  private sayacYenile$ = new Subject<void>();
  private bildirimSesi = new Audio('/assets/notification_sound.mp3');



  ngOnInit(): void {
    window.addEventListener('genBildirimEvent', this.eventHandler as EventListener);
    // eski hâli (06.10.2026): setInterval(this.getSayacGorevList.bind(this), 120000);  — hiç temizlenmiyordu
    // Hub'a bağlıyken sayaçlar olayla tazelenir, yoklama 5 dk'ya iner; bağlantı yokken 120 sn.
    this.realtimeAbonelik.add(this.sayacYenile$.pipe(auditTime(1000)).subscribe(() => this.getSayacGorevList()));
    this.realtimeAbonelik.add(this.realtime.bagli$.subscribe((bagli) => this.sayacYoklamaKur(bagli ? 300000 : 120000)));
    this.realtimeAbonelik.add(this.realtime.sayacDegisti$.subscribe(() => this.sayacYenile$.next()));
    this.realtimeAbonelik.add(
      this.realtime.bildirim$.subscribe((o) => {
        this.bildirimGoster(o);
        this.sayacYenile$.next();
      })
    );
    this.realtimeAbonelik.add(this.realtime.mesaj$.subscribe((o) => this.mesajGoster(o)));
    this.kullaniciBilgi$= this.ortakService.getKullaniciBilgi(devices.current().deviceType);
  }

   ngAfterViewInit() {
    this.getSayacGorevList()
  }

   async getSayacGorevList() {
    const res = await this.ortManuelService.GetGorevSayac_Request(
      new GetGorevSayac_Request({ sayacTur: 'tum' })
    );
    if (res?.response?.result) {
      this.bildirim = res?.response?.gorevSayacList;
      this.bildirimCount = this.bildirim.find((item) => item.gorevTipi === 'GenBildirim')?.adet || 0;
      this.updateToolbarItems();
    } else {
      this.bildirim = [];
    }
  }
  updateToolbarItems() {
    this.toolbarItems = this.toolbarData.map((item) => {
      var findSayac = this.bildirim.filter(
        (x: any) => x.gorevTipi === item.gorevTipi
      );
      item.routeLink = findSayac.length > 0 ? `${findSayac[0].url}` : '';
      return {
        ...item,
        sayac: findSayac.length > 0 ? `${findSayac[0].adet}` : 0,
        dynamicText: item.text,
        listeTuru: item.listeTuru || null,
        type: 'normal',
      };
    });
  }


  private sayacYoklamaKur(ms: number) {
    if (this.sayacZamanlayici) clearInterval(this.sayacZamanlayici);
    this.sayacZamanlayici = setInterval(() => this.getSayacGorevList(), ms);
  }

  /** Anlık bildirim: sağ altta toast; tıklanınca bildirimin formu kayıtla açılır (zildeki satıra tıklamakla aynı). */
  private bildirimGoster(o: BildirimOlay) {
    if (o.ses) {
      this.bildirimSesi.currentTime = 0;
      this.bildirimSesi.play().catch(() => {});
    }
    const t = this.toastr.info(o.metin || '', o.baslik || 'Bildirim', {
      timeOut: 8000,
      positionClass: 'toast-bottom-right',
      tapToDismiss: true,
    });
    t.onTap.pipe(take(1)).subscribe(() => {
      if (!o.formAd) return;
      if (this.router.url != '/main/dabnet') this.router.navigate(['/main/dabnet']);
      const request = new GetFormMetadata_Request({ formAd: o.formAd, altFormAd: '', kod: 0, logYn: false });
      this.ortakService.getFormMetadata(request).pipe(take(1)).subscribe((response) => {
        // Zildeki satıra tıklamakla aynı: sekme açıksa kapatılıp kayıtla yeniden açılır (form sendedData'yı açılışta okur)
        this.navService.pages$.pipe(take(1)).subscribe((pages) => {
          const acik = pages.find((p: any) => p?.path === o.formAd);
          if (acik && o.itemKod) this.navService.closeButtonHandler(acik);
          this.navService.addButtonHandler({
            path: o.formAd,
            text: response?.formMetadata?.formTitle || DkNavService.bilinenBaslik(o.formAd) || o.baslik || 'Bildirim',
            data: { sendedData: o.itemKod ? { Kod: o.itemKod, ac: Date.now() } : {} },
          });
        });
      });
    });
  }

  /** Yeni kurumsal mesaj: sağ altta bildirim; tıklanınca Görevlerim'de Gelen Kutusu o mesajla açılır. */
  private mesajGoster(o: MesajOlay) {
    if (o.ses) {
      this.bildirimSesi.currentTime = 0;
      this.bildirimSesi.play().catch(() => {});
    }
    const t = this.toastr.info(o.konu || '', `Yeni mesaj: ${o.gonderen || ''}`.trim(), {
      timeOut: 8000,
      positionClass: 'toast-bottom-right',
      tapToDismiss: true,
    });
    t.onTap.pipe(take(1)).subscribe(() => {
      if (this.router.url != '/main/dabnet') this.router.navigate(['/main/dabnet']);
      const yol = DkNavService.GOREVLERIM_YOLU;
      this.navService.pages$.pipe(take(1)).subscribe((pages) => {
        const acik = pages.find((p: any) => p?.path === yol);
        if (acik) this.navService.closeButtonHandler(acik);
        this.navService.addButtonHandler({ path: yol, text: 'Görevlerim', data: { sendedData: { MesajKod: o.mesajKod, ac: Date.now() } } });
      });
    });
  }

   ngOnDestroy() {
    this.surumAbonelik?.unsubscribe();
    this.realtimeAbonelik.unsubscribe();
    if (this.sayacZamanlayici) clearInterval(this.sayacZamanlayici);
    window.removeEventListener('genBildirimEvent', this.eventHandler as EventListener);
  }

  togglePopover() {
    this.isPopoverVisible = !this.isPopoverVisible;
    const dataToSend = {
      close: !this.isPopoverVisible,
      value: 'GenBildirim',
      visible: !this.isPopoverVisible,
    }
    window.dispatchEvent(new CustomEvent('genBildirimEvent', { detail: dataToSend }));
    
  }
  gotoMain = (event: any) => {
    this.router.navigate(['/main/dabnet']);
  };

  toggleMenu = () => {
    this.menuToggle.emit();
  };

  onRefresh(){
    this.hasNewVersion = false;
    location.reload();
  }

  onSchedular() {
    // GOR (Takvim) eski hâli: DevExtreme şablon demosu (js.devexpress.com demo API)
    // this.router.navigate(['/main/schedular']);
    this.navService.takvimiAc(this.router);
  }
  onTask() {
    // GOR (Görevlerim) eski hâli: DevExtreme şablon demosu (js.devexpress.com demo API)
    // this.router.navigate(['/main/task']);
    this.navService.gorevlerimiAc(this.router);
  }

  onPersonelInfo() {
    this.router.navigate(['/main/personel']);
  }

  /** Analiz Merkezi düğmesi: menüsünde Analiz Merkezi olan kullanıcıya görünür. */
  get analizMerkeziYetkili$() {
    return this.navService.analizMerkeziYetkili$;
  }

  onAnalizMerkezi() {
    this.navService.analizMerkeziniAc(this.router);
  }

   closeAfterPopup(e: any) {
      this.isPopoverVisible = false;
    }


    openFormClick(item: any) {
      console.log('openFormClick', item);
      if(this.router.url != '/main/dabnet') {
        this.router.navigate(['/main/dabnet']);
      }
       const request = new GetFormMetadata_Request({
             formAd: item.routeLink,
             altFormAd: '',
             kod: 0,
             logYn: false
           })
           this.ortakService.getFormMetadata(request).pipe(tap((response)=> {
               if (response) {
                var routeData:any ={
                  path: item.routeLink,
                  text: response.formMetadata.formTitle || 'Başlık yok',
                  data: { sendedData: { }}
                }
                if(item.listeTuru) routeData.data.sendedData.listeTuru = item.listeTuru;
               this.navService.addButtonHandler(routeData);
            }
           })).subscribe()
      }

}
